import React from 'react';

interface VulnerabilityManagementIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const VulnerabilityManagementIcon: React.FC<VulnerabilityManagementIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M9.99967 4.89583C9.53002 4.89583 9.0796 5.0824 8.74751 5.4145C8.41541 5.74659 8.22884 6.19701 8.22884 6.66667V7.5C8.22884 7.90271 7.90238 8.22917 7.49967 8.22917C7.09697 8.22917 6.77051 7.90271 6.77051 7.5V6.66667C6.77051 5.81024 7.11072 4.98889 7.71631 4.3833C8.32189 3.77771 9.14325 3.4375 9.99967 3.4375C10.8561 3.4375 11.6775 3.77771 12.283 4.3833C12.8886 4.98889 13.2288 5.81024 13.2288 6.66667V7.5C13.2288 7.90271 12.9024 8.22917 12.4997 8.22917C12.097 8.22917 11.7705 7.90271 11.7705 7.5V6.66667C11.7705 6.19701 11.5839 5.74659 11.2518 5.4145C10.9197 5.0824 10.4693 4.89583 9.99967 4.89583Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.06046 7.09532C6.19572 6.89261 6.4233 6.77087 6.66699 6.77087H13.3337C13.5774 6.77087 13.8049 6.89261 13.9402 7.09532C14.5089 7.94761 14.8386 8.93683 14.8951 9.9599C14.8958 9.97327 14.8962 9.98665 14.8962 10V12.5C14.8962 13.7985 14.3803 15.0438 13.4622 15.9619C12.5441 16.8801 11.2988 17.3959 10.0003 17.3959C8.70187 17.3959 7.4566 16.8801 6.53845 15.9619C5.6203 15.0438 5.10449 13.7985 5.10449 12.5V10C5.10449 9.98665 5.10486 9.97327 5.1056 9.9599C5.162 8.93683 5.49174 7.94761 6.06046 7.09532ZM7.07727 8.22921C6.77666 8.77998 6.60037 9.39163 6.56283 10.0209V12.5C6.56283 13.4117 6.92499 14.2861 7.56965 14.9307C8.2143 15.5754 9.08864 15.9375 10.0003 15.9375C10.912 15.9375 11.7863 15.5754 12.431 14.9307C13.0757 14.2861 13.4378 13.4117 13.4378 12.5V10.0209C13.4003 9.39163 13.224 8.77998 12.9234 8.22921H7.07727Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M1.77051 10.8333C1.77051 10.4306 2.09697 10.1041 2.49967 10.1041H5.83301C6.23572 10.1041 6.56217 10.4306 6.56217 10.8333C6.56217 11.236 6.23572 11.5625 5.83301 11.5625H2.49967C2.09697 11.5625 1.77051 11.236 1.77051 10.8333Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.4375 10.8333C13.4375 10.4306 13.764 10.1041 14.1667 10.1041H17.5C17.9027 10.1041 18.2292 10.4306 18.2292 10.8333C18.2292 11.236 17.9027 11.5625 17.5 11.5625H14.1667C13.764 11.5625 13.4375 11.236 13.4375 10.8333Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.99967 10.9375C10.4024 10.9375 10.7288 11.264 10.7288 11.6667V16.6667C10.7288 17.0694 10.4024 17.3958 9.99967 17.3958C9.59697 17.3958 9.27051 17.0694 9.27051 16.6667V11.6667C9.27051 11.264 9.59697 10.9375 9.99967 10.9375Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.75152 13.7929C6.95795 14.1387 6.84499 14.5863 6.49922 14.7927L3.70755 16.4594C3.36178 16.6658 2.91412 16.5529 2.70769 16.2071C2.50126 15.8613 2.61422 15.4137 2.95999 15.2072L5.75166 13.5406C6.09743 13.3341 6.54508 13.4471 6.75152 13.7929Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.2487 13.7929C13.4551 13.4471 13.9028 13.3341 14.2486 13.5406L17.0402 15.2072C17.386 15.4137 17.499 15.8613 17.2925 16.2071C17.0861 16.5529 16.6384 16.6658 16.2927 16.4594L13.501 14.7927C13.1552 14.5863 13.0423 14.1387 13.2487 13.7929Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M2.71959 5.44032C2.93667 5.10113 3.38762 5.00215 3.72681 5.21923L6.85181 7.21923C7.191 7.43631 7.28999 7.88725 7.07291 8.22644C6.85582 8.56563 6.40488 8.66462 6.06569 8.44754L2.94069 6.44754C2.6015 6.23046 2.50251 5.77951 2.71959 5.44032Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.2809 5.44032C17.498 5.77951 17.399 6.23046 17.0598 6.44754L13.9348 8.44754C13.5956 8.66462 13.1447 8.56563 12.9276 8.22644C12.7105 7.88725 12.8095 7.43631 13.1487 7.21923L16.2737 5.21923C16.6129 5.00215 17.0638 5.10113 17.2809 5.44032Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
